import { FC } from 'react'
import { StatusWidget } from '@revolut-internal/ui-kit'

export const EmptyTracesWidget: FC = () => {
  return (
    <StatusWidget>
      <StatusWidget.Image
        image={{
          default: 'https://assets.revolut.com/assets/3d-images-v2/3D086.png',
          '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D086@2x.png',
          '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D086@3x.png',
        }}
      />
      <StatusWidget.Title>No results found for selected message</StatusWidget.Title>
    </StatusWidget>
  )
}
